module.exports = __webpack_public_path__ + "img/1.bc7ad346.png";